import React from 'react'
import Link from "../Link/Link"

import iconFB from "../../../static/img/facebook.svg"
import iconIG from "../../../static/img/instagram.svg"
import iconTwitter from "../../../static/img/twitter.svg"
import iconYoutube from "../../../static/img/youtube.svg"
import iconLinkedin from "../../../static/img/linkedin.svg"
import iconTikTok from "../../../static/img/tiktok.svg"

export default class BrandFooter extends React.Component {
  render() {

    return (
      <div className="component-brand-footer">
        <div className="branding">
          <div className="brand-name">Beyond</div>
          <div className="brand-tag-line">People, ideas and actions for a better world</div>
        </div>
        <div className="brand-description">
          <p>
            Fueled by research experts, Beyond looks past the current reality to a different future. It provides a deeper understanding of today’s issues and offers solutions to help shape a better world.
            {' '}
            <Link to="/about/">About Beyond</Link>
          </p>
        </div>
        <div className="contact-information">
          <div id="ubc7-address-unit-name">Produced by UBC Brand and Marketing</div>
          <div id="ubc7-address-street">6323 Cecil Green Park Road</div>
          <div id="ubc7-address-location">
            <span id="ubc7-address-city">Vancouver</span>
            ,
            {' '}
            <span id="ubc7-address-province">BC</span>
            {' '}
            <span id="ubc7-address-country">Canada</span>
            {' '}
            <span id="ubc7-address-postal">V6T 1Z1</span>
          </div>
          <div><a href="https://brand.ubc.ca/support/contact-us/">Contact Us</a></div>
        </div>
        <div className="social-icons">
          <div id="ubc7-unit-social-icons">
            <a href="https://www.facebook.com/universityofbc" title="Facebook icon"><img src={iconFB} alt="Facebook" width="45" height="45" /></a>
            &nbsp;
            <a href="https://instagram.com/universityofbc/" title="Instagram"><img src={iconIG} alt="Instagram" width="45" height="45" /></a>
            &nbsp;
            <a href="https://twitter.com/ubc" title="Twitter icon"><img src={iconTwitter} alt="Twitter" width="45" height="45" /></a>
            &nbsp;
            <a href="https://www.linkedin.com/school/universityofbc/" title="LinkedIn icon"><img src={iconLinkedin} alt="LinkedIn" width="45" height="45" /></a>
            &nbsp;
            <a href="https://www.youtube.com/user/ubc" title="YouTube icon"><img src={iconYoutube} alt="Youtube" width="45" height="45" /></a>
            &nbsp;
            <a href="https://www.tiktok.com/@universityofbc" title="TikTok icon"><img src={iconTikTok} alt="TikTok" width="45" height="45" /></a>
            &nbsp;
          </div>
        </div>
      </div>
    )
  }
}
